import { useMutation } from "react-query";

import { CreateCorporationBody } from "g1-commons/lib/doxecureClientTypes";

import { createCorporation } from "@services/corporations.service";

const useCreateCorporation = () => useMutation((values: CreateCorporationBody) => createCorporation(values));

export default useCreateCorporation;
